import React, { useEffect, useState } from 'react';
import agent from '../../agent';
import useTranslation from '../../customHooks/translations';
import InfiniteScroll from 'react-infinite-scroller';
import { useMediaQuery } from 'react-responsive';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CircularProgress from '@mui/material/CircularProgress';
import PricesHistoryListComponent from '../List/PricesHistoryListComponent';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

const ShakePricesHistoryView = (props) => {
  const translation = useTranslation();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ minWidth: 992 });

  const [pricesHistory, setPricesHistory] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);

  const paddingLeft = (isDesktop && props.leftNavigationOpen) ? 300 : (isDesktop && !props.leftNavigationOpen ? 75 : 0);

  useEffect(() => {
    setPage(0);
    setPricesHistory([]);
    setHasMore(true);
    setIsLoading(true);
    loadMorePricesHistory(0);
  }, []);

  const loadMorePricesHistory = async () => {
    if (!hasMore) return;
    const results = await agent.Price.getHistory(page);
    setPricesHistory(prev => [...prev, ...results]);
    setPage(prev => prev + 1);
    setIsLoading(false);
    if (results.length === 0) setHasMore(false);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0d1b2a 0%, #091420 100%)',
        paddingLeft: `${paddingLeft}px`,
      }}
    >
      {/* ── Sticky header ── */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 3,
          py: 1.5,
          background: 'rgba(13,27,42,0.92)',
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(255,255,255,0.07)',
        }}
      >
        <IconButton
          onClick={() => navigate(-1)}
          size="small"
          sx={{ color: 'rgba(255,255,255,0.6)', '&:hover': { color: 'white' } }}
        >
          <ArrowBackIcon />
        </IconButton>
        <EmojiEventsIcon sx={{ color: DEFAULT_THEME_COLOR, fontSize: 22 }} />
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 600, fontSize: '1rem' }}>
          {translation.pricesHistory.title}
        </Typography>
      </Box>

      {/* ── List ── */}
      <Box sx={{ maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 3 }, py: 3 }}>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
            <CircularProgress sx={{ color: DEFAULT_THEME_COLOR }} />
          </Box>
        ) : (
          <InfiniteScroll
            pageStart={0}
            loadMore={loadMorePricesHistory}
            hasMore={hasMore}
            loader={
              <Box key="loader" sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                <CircularProgress size={24} sx={{ color: DEFAULT_THEME_COLOR }} />
              </Box>
            }
          >
            <PricesHistoryListComponent data={pricesHistory} />
          </InfiniteScroll>
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = state => ({
  leftNavigationOpen: state.common.leftNavigationOpen,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ShakePricesHistoryView);
